import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles, withTheme } from '@material-ui/styles';
import { IconButton, Modal, Typography } from '@material-ui/core';
import { AddCircleOutline, CheckCircleOutline } from '@material-ui/icons';
import ActionButton from '../../../../components/ActionButton';
import CustomTable from '../../components/CustomTable';

const styles = (theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: theme.spacing(3),
    padding: '20px 0',
    textAlign: 'center',
    backgroundColor: 'white',
    color: 'black',
    boxShadow: theme.shadows[6],
    borderRadius: '6px',
    width: '90%',
    maxWidth: '1020px',
    overflowY: 'auto',
  },
  modalTitle: {
    margin: theme.spacing(1, 0),
  },
  spanTitle: {
    backgroundColor: theme.palette.grey[300],
    padding: '4px 8px',
    borderRadius: '8px',
    fontWeight: 600,
  },
  tableContainer: {
    width: '90%',
  },
  buttonWrapper: {
    width: '90%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

class ModalResponsabiliPerReparto extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selection: [],
    };
  }

  componentDidMount() {
    let selection = this.getResponsabiliIds();
    this.setState({
      selection,
    });
  }

  getResponsabiliIds = () => {
    let output = [];
    if (
      this.props.reparto.responsabili !== undefined &&
      this.props.reparto.responsabili !== null
    ) {
      for (const responsabile of this.props.reparto.responsabili) {
        output.push(responsabile);
      }
    }
    return output;
  };

  updateSelection = (isAdded, id) => {
    const idNumber = Number(id);
    this.setState((prevState) => {
      let selection = prevState.selection.map(Number);
      if (isAdded) {
        if (!selection.includes(idNumber)) {
          selection.push(idNumber);
        }
      } else {
        selection = selection.filter((respId) => respId !== idNumber);
      }
      return { selection };
    });
  };

  onConfermaClicked = () => {
    this.props.onSubmit(this.state.selection);
  };

  render() {
    const { classes } = this.props;

    const columns = [
      {
        Header: 'ID',
        id: 'id',
        accessor: (d) => d.id,
        minWidth: 80,
      },
      {
        Header: 'Email',
        id: 'email',
        accessor: (d) => d.email,
        minWidth: 180,
      },
      {
        Header: 'Nome',
        id: 'nome',
        accessor: (d) => d.nome,
        minWidth: 120,
      },
      {
        Header: 'Cognome',
        id: 'cognome',
        accessor: (d) => d.cognome,
        minWidth: 120,
      },
      {
        id: 'associaResponsabileBtn',
        Header: 'Associa a reparto',
        accessor: (row) => row,
        sortable: false,
        filterable: false,
        resizable: false,
        width: 150,
        Cell: (props) =>
          this.state.selection.map(Number).includes(Number(props.value.id)) ? (
            <IconButton
              size="small"
              style={{ color: this.props.theme.palette.success.main }}
              disabled={false}
              onClick={() => {
                this.updateSelection(false, props.value.id);
              }}
            >
              <CheckCircleOutline />
            </IconButton>
          ) : (
            <IconButton
              size="small"
              color="primary"
              disabled={false}
              onClick={() => {
                this.updateSelection(true, props.value.id);
              }}
            >
              <AddCircleOutline />
            </IconButton>
          ),
      },
    ];

    return (
      <Modal
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        open={this.props.open}
        onClose={this.props.onClose}
        className={classes.modal}
      >
        <div className={classes.modalContainer}>
          <Typography variant="h5" className={classes.modalTitle}>
            Seleziona i responsabili per il reparto{' '}
            <span className={classes.spanTitle}>{this.props.reparto.nome}</span>
          </Typography>
          <div className={classes.tableContainer}>
            <CustomTable
              columns={columns}
              records={this.props.responsabiliEsercizio}
              loading={false}
              filterable={true}
              resizable={true}
              sortable={true}
              defaultPageSize={5}
            />
          </div>
          <div className={classes.buttonWrapper}>
            <ActionButton
              label="Chiudi"
              secondaryButton
              onClick={this.props.onClose}
              disabled={false}
              grayVersion={false}
            />
            <ActionButton
              label="Salva"
              onClick={this.onConfermaClicked}
              disabled={false}
              grayVersion={false}
            />
          </div>
        </div>
      </Modal>
    );
  }
}

ModalResponsabiliPerReparto.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  reparto: PropTypes.object.isRequired,
  responsabiliEsercizio: PropTypes.array.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withTheme(withStyles(styles)(ModalResponsabiliPerReparto));
